import type { Block, BooleanBlock } from '@basehub/data/replicache/index'

export const BooleanBlockPropertiesPanel = (_props: {
  block: BooleanBlock
  parent: Block
  path: string
}) => {
  return null
}
